export const PermissionRoles = {
    PUT: "mgr-roles-PUT",
    POST: "mgr-roles-POST",
    DELETE: "mgr-roles-DELETE",
    GET: "mgr-roles-GET",
    GET_UUID: "mgr-roles-GET"
};